"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.dereferenceOpenAPI = void 0;
var draft_2020_12_1 = require("@criteria/json-schema/draft-2020-12");
var dereferenceOpenAPI_1 = require("../../dereferencing/dereferenceOpenAPI");
// TODO: dialect should be OAS
function dereferenceOpenAPI(openAPI, options) {
    return (0, dereferenceOpenAPI_1.dereferenceOpenAPI)(openAPI, __assign(__assign({}, options), { defaultJSONSchemaDialect: draft_2020_12_1.metaSchemaURI }));
}
exports.dereferenceOpenAPI = dereferenceOpenAPI;
